<template>
  <div v-if="isShow">
    <div class="main-wrap bg_white pt16">
      <h2 class="content_title">有効期間</h2>
      <div class="bc_wrap mt16 ml16 mr16">
        <p class="bc rr">BC</p>
        <div class="select_wrap bdb">
          <select class="select_bc rb" name="bc_number" v-model="nowBC">
            <option v-for="(index, n) in bcList" v-bind:value="index" :key="n">{{ index }}</option>
          </select>
        </div>
      </div>

      <div class="main_contents">
        <!-- 当月 -->
        <section class="this-month">
          <div class="text-area">
            <p class="year" id="year1">2021</p>
            <p class="month">当月</p>
            <div class="period" id="period1">
              <p class="start" id="start1">{{ this.term.currentTerm.start }}</p>
              <p class="tilde">~</p>
              <p class="end" id="end1">{{ this.term.currentTerm.end }}</p>
            </div>
          </div>
          <div class="circle-wrap">
            <div class="circle-box" id="circle1">
              <div class="item" v-for="(index, n) in month" v-bind:style="monthCss[n]" v-bind:class="{'regist-date': index.bcRegistrationDate, 'today': index.today, 'expired': index.status == 'INVALID', 'occurrence': index.status == 'VALID', 'prospect': index.status == 'VALID_EXPECT', 'none': index.status == 'NONE'}" :key="n"></div>
            </div>
          </div>
          <div class="text-wrap">
            <div class="text-box" id="text1">
              <div class="text" v-bind:style="monthTextCss[n]" v-for="(index, n) in month" :key="n" v-bind:class="{'regist-date': index.bcRegistrationDate, 'today': index.today}">
                <span class="rm" v-if="index.limitDate == '1'">1<span class="circle_day">日</span></span>
                <span class="rm" v-if="index.today">{{ index.limitDate | moment('D') }}<span class="circle_day">日</span></span>
                <span class="rm" v-if="index.bcRegistrationDate">{{ index.limitDate | moment('D') }}<span class="circle_day">日</span></span>
              </div>
            </div>
          </div>
        </section>
        <!-- 翌月 -->
        <section class="next-month">
          <div class="text-area">
            <p class="year" id="year2">2021</p>
            <p class="month">翌月</p>
            <div class="period" id="period2">
              <p class="start" id="start2">{{ this.term.nextTerm.start }}</p>
              <p class="tilde">~</p>
              <p class="end" id="end2">{{ this.term.nextTerm.end }}</p>
            </div>
          </div>
          <div class="circle-wrap">
            <div class="circle-box" id="circle2">
              <div class="item" v-for="(index, n) in nextMonth" v-bind:style="nextMonthCss[n]" v-bind:class="{'regist-date': index.bcRegistrationDate, 'today': index.today, 'expired': index.status == 'INVALID', 'occurrence': index.status == 'VALID', 'prospect': index.status == 'VALID_EXPECT', 'none': index.status == 'NONE'}" :key="n"></div>
            </div>
          </div>
          <div class="text-wrap">
            <div class="text-box" id="text2">
              <div class="text" v-bind:style="nextMonthTextCss[n]" v-for="(index, n) in nextMonth" v-bind:class="{'regist-date': index.bcRegistrationDate, 'today': index.today}" :key="n">
                <span class="rm" v-if="index.limitDate == '2021/09/01'">1<span class="circle_day">日</span></span>
                <span class="rm" v-if="index.today">{{ index.limitDate | moment('D') }}<span class="circle_day">日</span></span>
                <span class="rm" v-if="index.bcRegistrationDate">{{ index.limitDate | moment('D') }}<span class="circle_day">日</span></span>

              </div>
            </div>
          </div>
        </section>
        <!-- 説明 -->
        <section class="description rm">
          <ul>
            <li>有効期間発生</li>
            <li>有効期間なし</li>
            <li>有効期間発生見込み</li>
            <li>登録日</li>
            <li>有効期間切れ</li>
            <li>今日</li>
          </ul>
        </section>
      </div>
    </div>
  </div>
  <div v-else class="bg_white pt16 pb16 pl16 pr16 ab">アクセスエラー<br>coNPusアプリから再度開き直してください。</div>
</template>

<script>
import moment from 'moment';
import LimitDate from '@/components/api/limitDate'
import Bc from '@/components/api/bc'
// import Login from '@/components/api/auth'

import Check from '@/model/getToken'

const today = new Date();
export default {
  data() {
    return {
      isShow: true,
      nowBC: '',
      bcList: [],
      term: { currentTerm: { start: '', end: '' }, nextTerm: { start: '', end: '' } },
      month: [],
      monthCss: [],
      monthTextCss: [],
      nextMonth: [],
      nextMonthCss: [],
      nextMonthTextCss: []
    }
  },
  methods: {
    apiGetBcList() {
      Bc.bcList().then((val) => {
        this.bcList.splice(0, this.bcList.length);
        for (var i = 0; i < val.bcNoList.length; i++) {
          this.bcList.push(val.bcNoList[i]);
        }
        // const limitNowBC = localStorage.getItem('limitDateNowBC');
        // if(limitNowBC != null) {
        //   this.nowBC = limitNowBC;
        // }else {
          this.nowBC = this.bcList[0];
        // }

        // localStorage.setItem('limitDateNowBC', this.nowBC);
      });
    },
    apiGetLimitDateListInit() {
      this.month.splice(0, this.month.length);
      this.monthCss.splice(0, this.monthCss.length);
      this.monthTextCss.splice(0, this.monthTextCss.length);
      this.nextMonth.splice(0, this.nextMonth.length);
      this.nextMonthCss.splice(0, this.nextMonthCss.length);
      this.nextMonthTextCss.splice(0, this.nextMonthTextCss.length);
    },
    apiGetLimitDateList() {
      LimitDate.getLimitDateList().then((val) => {
        this.apiGetLimitDateListInit(); // 配列初期化

        this.term.currentTerm.start = val.currentMonth.termStart;
        this.term.currentTerm.end = val.currentMonth.termEnd;
        this.term.nextTerm.start = val.nextMonth.termStart;
        this.term.nextTerm.end = val.nextMonth.termEnd;

        let month = this.filterDate(val.limitDateList, val.currentMonth.termStart, val.currentMonth.termEnd);
        this.month.push(...month);

        let next = this.filterDate(val.limitDateList, val.nextMonth.termStart, val.nextMonth.termEnd);
        this.nextMonth.push(...next);

        this.monthInit();
        this.nextMonthInit();
      });
    },
    filterDate(dataList, startDate, endDate) {
      const data = dataList.filter(function(value) {
        return startDate <= value.limitDate && endDate >= value.limitDate;
      });
      return data;
    },
    calcCircle(selectMonth, selectMonthLength, type) {
      var item_num = selectMonthLength;
      var deg = 360.0/item_num;
      var red = (deg*Math.PI/180.0);
      if(type == 'circle') {
        var circle_r = 15 * 6; // .itemのwidth15
      }else if(type == 'textCircle') {
        var circle_r = 16.5 * 6.7; // .itemのwidth15
      }

      for (var i = 0; i < item_num; i++) {
        var x = Math.cos(red * i - Math.PI/2) * circle_r + circle_r;
        var y = Math.sin(red * i - Math.PI/2) * circle_r + circle_r;
        let data = {'left': x + 'px', 'top': y + 'px' }
        if(selectMonth == 'month' && type == 'circle') {
          this.monthCss.push(data);
        }else if(selectMonth == 'nextMonth' && type == 'circle') {
          this.nextMonthCss.push(data);
        }else if(selectMonth == 'month' && type == 'textCircle'){
          this.monthTextCss.push(data);
        }else if(selectMonth == 'nextMonth' && type == 'textCircle') {
          this.nextMonthTextCss.push(data);
        }
      }
    },
    monthInit() {
      // this.thisMonthData();
      this.calcCircle('month', this.month.length, 'circle');
      this.calcCircle('month', this.month.length, 'textCircle');
    },
    nextMonthInit() {
      // this.nextMonthData();
      this.calcCircle('nextMonth', this.nextMonth.length, 'circle');
      this.calcCircle('nextMonth', this.nextMonth.length, 'textCircle');
    }
  },
  async created() {
    let res;
    await Check.checkRequest(this.$route.query.code).then((val) => { res = val; });
    if(res) {
      this.apiGetBcList();
    } else {
      this.isShow = false;
    }
  },
  watch: {
    nowBC: function() {
      localStorage.setItem('limitDateNowBC', this.nowBC);
      this.apiGetLimitDateList();
    }
  }
}
</script>

<style lang="css" scoped>
.content_title {
  width: 109px;
}
.bc {
  color: #878787;
  font-size: 12px;
}
.select_wrap::after {
  right: 0;
  top: 0;
}
.select_bc {
  font-size: 16px;
  width: 100%;
}

.main_contents {
  margin-top: 60px;
}
/* ----------------------
大枠
------------------------- */
.main-wrap{
  padding-bottom: 50px;
}

/* ----------------------
当月&翌月
------------------------- */

.this-month,.next-month {
  position: relative;
  width: 100%;
  padding: 60px 0%;
  /* margin: 30px 0; */
}


/* テキスト部分 */
.text-area{
  /* transform: translateY(-15px); */
  transform: translateY(-32px);
  text-align: center;
}
.text-area .year{
  /* display: flex;
  justify-content: space-between; */
  width: 60px;
  margin: auto;
  color: #5e5e5e;
  /* font-size: 14px; */
  font-size: 12px;
  font-weight: bold;
  letter-spacing: 5.7px;
  text-indent: 5.7px;
}

.text-area .month{
  /* font-size: 350%; */
  font-size: 34px;
  font-weight: bold;
  color: #5e5e5e;
  text-align: center;
}
.text-area .start, .text-area .end {
  line-height: 1;
}
.text-area .period{
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  color: #5e5e5e;
  font-size: 14px;
  margin-top: 10px;
}

.tilde {
  line-height: 1;
  transform: rotate(90deg);
}



/* サークルのレイアウト */
.circle-wrap{
  position: absolute;
  top: 0px;
  right: 0;
  bottom: 0;
  left: 0;
  margin: auto;
  overflow: hidden;
}

.circle-box {
  position: relative;
  margin: 0 auto;
  /* width: 262px; */
  width: 195px;
  height: 100%;
  z-index: 1;
}
.item {
  position: absolute;
  /* width: 20px;
  height: 20px; */
  height: 15px;
  width: 15px;
  -webkit-border-radius: 20px;
  -moz-border-radius: 20px;
  border-radius: 20px;
  background-color: #f2f2f2;
}

/* 有効期間切れ */
.item.expired{
  background-color: #fed700;
}

/* 有効期間発生 */
.item.occurrence{
  background-color: #0fff7f;
}

/* 有効期間発生見込み */
.item.prospect{
  background-color: #04c2fe;
}

/* 有効期間なし */
.item.none{
  background-color: #f2f2f2;
}

/* 登録日 */
.item.regist-date{
  background-color: #fff;
  border: 2px solid #196eff;
  box-sizing: border-box;
}

/* 今日 */
.item.today{
  background-color: #fff;
  border: 2px solid #fe3f3f;
  box-sizing: border-box;
}

.item.regist-date.today{
  background-color: #fff;
  border: 2px solid #196eff;
  box-sizing: border-box;
}

.item.today::before,
.item.regist-date.today::before{
  content: '';
  width: 50%;
  height: 50%;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  margin: auto;
  position: absolute;
  background-color: #fe3f3f;
  border-radius: 50%;
}


.circle_day {
  font-size: 12px;
}
/* サークルの周囲のテキストレイアウト */
.text-wrap{
  position: absolute;
  top: -22px;
  right: 0;
  bottom: 0;
  left: 0;
  margin: auto;
  width: 100%;
}

.text-box {
  position: relative;
  margin: 0 auto;
  height: 100%;
  width: 244px;
  z-index: 1;
}
.text {
  font-size: 14px;
  position: absolute;
  /* height: 15px;
  width: 15px; */
  -webkit-border-radius: 20px;
  -moz-border-radius: 20px;
  border-radius: 20px;
  white-space: nowrap;
}

/* 1日 */
.text:first-child{
}

/* 登録日 */
.text.regist-date{
  color: #196eff;
}

/* 今日 */
.text.today{
  color: #fe3f3f;
}


.text:first-child,
.text.regist-date,
.text.today{
  font-size: 14px;
}



/* ----------------------
説明
------------------------- */
.description{
  max-width: 297px;
  margin: auto;
}

.description ul{
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;

}

.description ul li{
  position: relative;
  /* width: calc(49% - 1px); */
  padding-left: 18px;
  font-size: 14px;
  letter-spacing: 1.7px;
}

.description ul li:nth-child(odd) {
  width: 55%;
}
.description ul li:nth-child(even) {
  width: 40%;
}

.description ul li:nth-child(n+3){
  margin-top: 10px;
}

.description ul li::before{
  content: '';
  width: 14px;
  height: 14px;
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  margin: auto;
  border-radius: 50%;
}

.description ul li:nth-child(1)::before{
  background-color: #0fff7f;

}

.description ul li:nth-child(2)::before{
  background-color: #f2f2f2;

}

.description ul li:nth-child(3)::before{
  background-color: #04c2fe;

}

.description ul li:nth-child(4)::before{
  border: 2px solid #196eff;
  box-sizing: border-box;
}

.description ul li:nth-child(5)::before{
  background-color: #fed700;

}

.description ul li:nth-child(6)::before{
  border: 2px solid #fe3f3f;
  box-sizing: border-box;
}

.description ul li:nth-child(6)::after{
  content: '';
  width: 6px;
  height: 6px;
  top: 0;
  bottom: 0;
  left: 4px;
  margin: auto;
  position: absolute;
  background-color: #fe3f3f;
  border-radius: 50%;
}

</style>



// WEBPACK FOOTER //
// src/views/member/LimitDate.vue